export default class InativacaoLoteItemModel {
  constructor(
    {
      id,
      tipoItem,
      operacao,
      cnpjOrigem,
      empresaOrigemNome,
      cnpjDestino,
      empresaDestinoNome,
      identificadorSubDado,
      descricao,
      erros,
      alertas,
      avisos,
    } = new Object()
  ) {
    this._id = id;
    this._tipoItem = tipoItem;
    this._operacao = operacao;
    this._cnpjOrigem = cnpjOrigem;
    this._empresaOrigemNome = empresaOrigemNome;
    this._cnpjDestino = cnpjDestino;
    this._empresaDestinoNome = empresaDestinoNome;
    this._identificadorSubDado = identificadorSubDado;
    this._descricao = descricao;
    this.erros = erros;
    this.alertas = alertas;
    this.avisos = avisos;
  }

  get id() {
    return this._id;
  }

  set id(id = null) {
    this._id = id;
  }

  get tipoItem() {
    return this._tipoItem;
  }

  set tipoItem(tipoItem = null) {
    this._tipoItem = tipoItem;
  }

  get operacao() {
    return this._operacao || "INATIVAR";
  }

  set operacao(operacao = "INATIVAR") {
    this._operacao = operacao;
  }

  get cnpjOrigem() {
    return this._cnpjOrigem || null;
  }

  set cnpjOrigem(cnpjOrigem = null) {
    this._cnpjOrigem = cnpjOrigem;
  }

  get empresaOrigemNome() {
    return this._empresaOrigemNome || null;
  }

  set empresaOrigemNome(empresaOrigemNome = null) {
    this._empresaOrigemNome = empresaOrigemNome;
  }

  get cnpjDestino() {
    return this._cnpjDestino || null;
  }

  set cnpjDestino(cnpjDestino = null) {
    this._cnpjDestino = cnpjDestino;
  }

  get empresaDestinoNome() {
    return this._empresaDestinoNome || null;
  }

  set empresaDestinoNome(empresaDestinoNome = null) {
    this._empresaDestinoNome = empresaDestinoNome;
  }

  get identificadorSubDado() {
    return this._identificadorSubDado || null;
  }

  set identificadorSubDado(identificadorSubDado = null) {
    this._identificadorSubDado = identificadorSubDado;
  }

  get descricao() {
    return this._descricao || null;
  }

  set descricao(descricao = null) {
    this._descricao = descricao;
  }

  get erros() {
    return this._erros || new Array();
  }

  set erros(erros = null) {
    this._erros = Array.isArray(erros) ? erros : new Array();
  }

  get alertas() {
    return this._alertas || new Array();
  }

  set alertas(alertas = null) {
    this._alertas = Array.isArray(alertas) ? alertas : new Array();
  }

  get avisos() {
    return this._avisos || new Array();
  }

  set avisos(avisos = null) {
    this._avisos = Array.isArray(avisos) ? avisos : new Array();
  }

  /**
   * @summary Categoria visual da linha na tabela de prévia:
   * "erro" bloqueia a confirmação, "alerta" chama atenção sem bloquear,
   * "aviso" é informativo (ex.: "já inativo") e "ok" não tem nenhuma observação.
   */
  get categoria() {
    if (this.erros.length > 0) return "erro";
    if (this.alertas.length > 0) return "alerta";
    if (this.avisos.length > 0) return "aviso";
    return "ok";
  }

  get isTransferencia() {
    return this.operacao === "TRANSFERIR";
  }

  /**
   * @summary Mensagens da categoria vigente (erros, senão alertas, senão
   * avisos), na mesma ordem de precedência usada por `categoria`.
   */
  get mensagens() {
    if (this.erros.length > 0) return this.erros;
    if (this.alertas.length > 0) return this.alertas;
    return this.avisos;
  }

  get bloqueiaConfirmacao() {
    return this.categoria === "erro";
  }
}
